import Head from 'next/head'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Articles from '../../components/Articles'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import blog from '../../services/blog'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const ArticlesContainer = styled.div`
  flex: 1;
`

const Blog = () => {
  const { t } = useTranslation('common')
  const router = useRouter()
  const articles = blog.getArticlesByLanguage(router.locale)

  return (
    <Wrapper>
      <Head>
        <title>{t('blog.title')} | DreamCar</title>
      </Head>
      <Header blog />
      <ArticlesContainer>
        <Articles articles={articles} />
      </ArticlesContainer>
      <Footer blog />
    </Wrapper>
  )
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  }
}

export default Blog
